<template>
    <div
        v-if="cartBoxBanner.desktopImage"
        class="text-center mb-0 mb-md-3 px-2 px-md-0"
        ref="banner"
        :data-id="cartBoxBanner.id"
        :data-title="cartBoxBanner.title"
    >
        <a :href="cartBoxBanner.url" class="cartbox-banner js-cartbox-banner px-2 pt-3 pb-2">
            <img :src="`${cartBoxBanner.desktopImage}`" :alt="cartBoxBanner.title" class="img-fluid lazyload d-none d-md-block" />
            <img :src="`${cartBoxBanner.mobileImage}`" :alt="cartBoxBanner.title" class="img-fluid lazyload d-md-none" />
        </a>
    </div>
</template>

<script>
export default {
    props: {
        cartBoxBanner: {
            type: Object,
            required: true,
        },
    },
    methods: {
        useMatomoViewportTrack(htmlEl, options) {
            if (!htmlEl || !options) {
                return
            }

            if (!window._paq) {
                return
            }

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(({ isIntersecting }) => {
                    if (isIntersecting) {
                        setTimeout(() => {
                            window._paq.push(['trackEvent', options.category, options.action, options.name, options.value])
                        }, 0)
                        observer.disconnect()
                    }
                })
            })

            observer.observe(htmlEl)
        },

        useMatomoClickTrack(htmlEl, options) {
            if (!htmlEl || !options) {
                return
            }

            if (!window._paq) {
                return
            }

            htmlEl.addEventListener('click', () => {
                window._paq.push(['trackEvent', options.category, options.action, options.name, options.value])
            })
        },
    },

    mounted() {
        const element = this.$refs.banner
        this.useMatomoViewportTrack(element, {
            category: 'Cart Box Banner',
            action: 'view',
            name: this.cartBoxBanner.title,
            value: +this.cartBoxBanner.id,
        })

        this.useMatomoClickTrack(element, {
            category: 'Cart Box Banner',
            action: 'click',
            name: this.cartBoxBanner.title,
            value: +this.cartBoxBanner.id,
        })
    },
}
</script>
